import { useAuth } from '../auth/AuthContext'
import { useT } from '../lib/i18n'
import { useAppTouchScope } from '../lib/touchGuard'
import { SUPPORT_MAIL, SUPPORT_MAILTO } from '../lib/support'
import Logo from '../components/Logo'
import { Button, Glyph, Icon } from '../ds'
import './pending-panel.css'

/**
 * Konto ODRZUCONE (sesja 11, artboard 08; decyzja 6): goła powłoka — pasek z logo
 * po lewej i chipem użytkownika po prawej, ZERO nawigacji, bo konto nie ma dostępu do
 * aplikacji i pasek z Pulpitem byłby obietnicą bez pokrycia. Na tle `--bg` jedna karta
 * (max 460 px): glif „konto” 48 w tonie ostrzeżenia, tytuł, zdanie z REALNYM adresem
 * wsparcia jako `mailto:` (ten sam moduł co onboarding — G2-auth-onboarding-04) i jedna
 * akcja: wylogowanie. Mobile-first: jedna kolumna, cel dotyku 44 px.
 *
 * JEDEN wariant. Stan „oczekujące” obsługuje krok onboardingu „Sprawdzamy Twoje konto”
 * (`OnboardingView`), a `RequireApproved` montuje ten panel WYŁĄCZNIE dla `rejected`
 * (G2-auth-onboarding-15) — martwa gałąź i jej klucze `pending.title` / `pending.body`
 * zostały usunięte. Serwer i tak 403-uje każdy uprzywilejowany endpoint (gate.py).
 */
export default function PendingPanel() {
  // Phone touch contract (MINIMAL-2026-09-18). `RequireApproved` renders this panel
  // INSTEAD of the app shell, so neither Layout nor AuthShell is mounted and the whole
  // of styles/touch.css — keyed to `html.is-app` — would miss the one screen a rejected
  // account ever sees: a pull-down at the top would reload it, the tap flash would stay,
  // and "Wyloguj się" would have no pressed state. The scope is reference-counted, so
  // overlapping with a shell during a route change is safe.
  useAppTouchScope()
  const { user, logout } = useAuth()
  const t = useT()
  const name = (user?.display_name || '').trim() || user?.email || ''
  const initial = (name || '?').charAt(0)

  return (
    <div className="pend-shell" data-testid="pending-panel">
      <header className="pend-bar">
        {/* The product's lockup, not a second one. This was a hand-rolled wordmark: the
            values of `.logo` (edimi.css: weight 700, letter-spacing 4px, size 21px) copied
            inline, the name typed in CAPITALS, and no logo mark at all — while everywhere
            else the brand is <LogoMark/> + a lowercase "edimi" (Logo.tsx:34). Found by the
            po-walk of 7491446, which reads the first visible line of every frame: 160 of
            164 said "edimi" and four said "EDIMI" — these two screens, in both languages.

            It is the worst possible screen to carry a different brand on: a tenant who has
            just registered sees this one FIRST, before any part of the app. The house
            pattern for a standalone lockup is one line (LegalShell.tsx:104). */}
        <div className="logo"><Logo /></div>
        {name && (
          <span className="user-chip pend-user" data-testid="pending-user">
            <span className="uc-ava" aria-hidden="true">{initial}</span>
            <span className="uc-txt"><span className="uc-name">{name}</span></span>
          </span>
        )}
      </header>
      <main className="pend-main">
        <div className="card pend-card">
          <div className="ds-state" data-testid="pending-rejected">
            <div className="ds-state-ic tone-warn" aria-hidden="true"><Glyph name="konto" size={48} tone="current" /></div>
            <h1>{t('pending.rejectedTitle')}</h1>
            <p>
              {t('pending.rejectedBody')}{' '}
              <a className="pend-mail" href={SUPPORT_MAILTO} data-testid="pending-mailto"><Icon name="Mail" size={16} />{SUPPORT_MAIL}</a>
            </p>
            <div className="ds-state-actions">
              <Button variant="secondary" onClick={() => logout()}>{t('pending.logout')}</Button>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}
